/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const DsoBarChartComp = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: 'Entity Wise',
        data: data.map((item) => item.dso_days),
        backgroundColor: ['#2196F3'],
        backgroundColor: (ctx) => {
          const value = ctx.raw;
          return value < 0 ? "red" : ['#2196F3'];
        },
        borderRadius: 2,
        barPercentage:0.6,
        barThickness: 30,
      },
    ],
  };

  const options = {
    // indexAxis: indexAxis,
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,
      },
    },
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10
          },
        },
        // onClick(e) {
        //   if (e.stopPropagation) e.stopPropagation();
        // },
        position: "bottom",
      }, 
      datalabels: {
        color: "black",
        textStrokeColor: "white",
        textStrokeWidth: 4,
        anchor: "end",
        align: "end",
        // rotation: 90, 
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        display: true,
        fontWeight: "bold",
        ticks: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
      y: {
        stacked: "normalized",
        display: true,
        fontWeight: "bold",
        ticks: {
          display: true,
        },
        grid: {
          display: true,
        },
      },
    },
  };
  
  return (
    <div style={{ width: '100%', maxWidth: '100%', height: '300px' }}>
        <Bar data={chartData} options={options}/>
    </div>
  );
};

export default DsoBarChartComp;
